export default {
    actualListDesign: state => state.actualDesign,
    filteredListDesignInCart: (state, getters, rootState, rootGetters) => {
        return state.actualDesign.filter(design => {
            return rootGetters["carrito/reprocesosFilter"].some(r => r.id == design.id && r.zona == design.zona);
        });
    },
    activeZonesId: state => state.activeZonesId,
    imgInfoCanvas3d: state => state.imgInfoCanvas3d,
    loadingDesign: state => state.loadingDesign > 0,
    bocetosRepeticion: (state, getters, rootState, rootGetters) => state.bocetosRepeticion.filter(
        // Comprobamos que id se encuentra en carrito.reprocesos
        b => rootGetters["carrito/reprocesosFilter"].some(r => r.id == b.id)
    ),
    getDesignByIdAndZone: (state, getter) => ({ id, posicion }) => {
        return getter.filteredListDesignInCart.find(design => design.id == id && design.posicion == posicion);
    },
    numDesignForEachPosition: (state, getter) => {
        return getter.filteredListDesignInCart.reduce((numDesign, design) => {
            numDesign[design.zona] = (numDesign[design.zona] || 0) + 1;
            return numDesign;
        }, {});
    },
    numDesignForEachPreviewRule: (state, getter, rootState, rootGetters) => {
        return getter.filteredListDesignInCart.reduce((numDesign, design) => {
            let idPreviewRule = rootGetters["modelo/zonasMappedByPosicion"]?.[design.posicion]?.PreviewRule;
            if (idPreviewRule)
                numDesign[idPreviewRule] = (numDesign[idPreviewRule] || 0) + 1;
            return numDesign;
        }, {});
    },
    previewGlobalDesign: (state, getters, rootState, rootGetters) => {
        let designPosition = null;
        let designPreviewRule = null;
        let numDesign = 0;
        Object.keys(getters.numDesignForEachPosition).forEach(item => {
            if (!designPosition || getters.numDesignForEachPosition[item] > numDesign) {
                designPosition = item;
                numDesign = getters.numDesignForEachPosition[item];
            }
        });

        Object.keys(getters.numDesignForEachPreviewRule).forEach(item => {
            if (!designPosition || getters.numDesignForEachPreviewRule[item] > numDesign) {
                designPreviewRule = item;
                numDesign = getters.numDesignForEachPreviewRule[item];
            }
        });

        const hasZoneDesign = designPosition && getters.numDesignForEachPosition[designPosition] > 0;
        const hasPreviewRule = designPreviewRule && getters.numDesignForEachPreviewRule[designPreviewRule] > 0;
        let zonesFromSamePreviewRule = [];
        if (hasPreviewRule) {
            Object.keys(rootGetters["modelo/zonasMappedByPosicion"]).forEach(posicion => {
                let previewRule = rootGetters["modelo/zonasMappedByPosicion"][posicion].PreviewRule;
                if (previewRule == designPreviewRule)
                    zonesFromSamePreviewRule.push(rootGetters["modelo/zonasMappedByPosicion"][posicion]);
            });
        }
        else if (hasZoneDesign) {
            zonesFromSamePreviewRule.push(rootGetters["modelo/zonas"].find(z => z.Zona == designPosition));
        }
        return {
            hasZoneDesign,
            hasPreviewRule,
            zones: [...zonesFromSamePreviewRule],
            designPreviewRule
        };
    },
    activeZone3D: state => state.activeZone3D,
    rotateDesignState: state => state.rotateDesignState,
    activeZoneMaxSize: (state, getters, rootState, rootGetter) => {
        let actualTecnicaInfo = rootGetter['carrito/infoTecnicaActualZone']?.info;
        let actualZone = rootGetter['carrito/infoTecnicaActualZone']?.zone;

        if (!actualTecnicaInfo || !actualZone || !actualZone?.Posicion) {
            console.warn("No podemos calcular las dimensiones de la zona más grande para la técnica/zona actual");
            return;
        }

        let result = rootGetter['carrito/unidadMasGrande']({
            posicion: actualZone.Posicion,
            tecnica: !actualTecnicaInfo?.valueTecnica
                ? null
                : actualTecnicaInfo.valueTecnica.startsWith("Serigrafia")
                    ? "Serigrafia"
                    : actualTecnicaInfo.valueTecnica.startsWith("Transfer")
                        ? "Transfer"
                        : rootGetter['config/sublimacionTecnicas'].includes(actualTecnicaInfo.valueTecnica)
                            ? "Sublimacion"
                            : actualTecnicaInfo.valueTecnica.replace("Stm", "")
        })

        if (!result) {
            result = rootGetter['carrito/unidadMasGrande']({
                posicion: actualZone.Posicion,
            });
        }

        return result;
    }
}